import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

import type { InvoiceRow, PaymentRow } from '../types';

export interface ApprovalRequestRow {
  id: string;
  invoice_id: string;
  status: string;
  required_approvers: string[];
  rule_key: string;
  rule_label: string;
  issuer_company_name: string | null;
  supplier_company_name: string | null;
  warning_message: string | null;
  created_at: string;
  updated_at: string;
}

export interface EasyBillEventRow {
  id: string;
  source: string;
  easybill_document_id: string;
  easybill_document_type: string;
  easybill_document_number: string | null;
  event_type: string;
  resolved_order_id: string | null;
  resolved_bl_order_id: string | null;
  resolved_invoice_type: string | null;
  resolved_invoice_direction: string;
  matched_invoice_ids: string[];
  reconciliation_status: string;
  error_message: string | null;
  retry_count: number;
  confidence_score: string | null;
  notes: string | null;
  confirmed_by: string | null;
  confirmed_at: string | null;
  is_test: boolean;
  easybill_delivery_id: string | null;
  event_date: string | null;
  created_at: string;
}

export interface InvoiceDetail {
  invoice: InvoiceRow;
  payments: PaymentRow[];
  approval_requests: ApprovalRequestRow[];
  easybill_event: EasyBillEventRow | null;
}

export function invoiceDetailKey(invoiceId: string | null | undefined) {
  return ['invoice-detail', invoiceId] as const;
}

export function useInvoiceDetail(invoiceId: string | null | undefined) {
  return useQuery<InvoiceDetail>({
    queryKey: invoiceDetailKey(invoiceId),
    enabled: typeof invoiceId === 'string' && invoiceId.length > 0,
    queryFn: () => apiRequest<InvoiceDetail>(`/invoices/${encodeURIComponent(invoiceId ?? '')}`),
  });
}
